import {Tr, TrSpace} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import {ManualLink} from "@/scenes.ui/manual-link";
import {VerticalLongPanel} from "@/scenes.ui/vertical-long-panel";
import PlayerStore from "@/store/player";
import {StatusDto, WheelStatusDto} from "@/store/player/types";
import BaseSound = Phaser.Sound.BaseSound;
import SoundUtils from "@/utils/sound-utils";
import SpriteUtils from "@/utils/sprite-utils";
import {TabName} from "@/services/shop-service";
import {CampaignWheelPanel2} from "@/scenes.ui/campaign-wheel-panel2";
import {StringUtils} from "@/utils/string-utils";
import {WingedLongPanel} from "@/scenes.ui/winged-long-panel";
import CU from "@/utils/c-u";

export class CampaignWheelPanel extends WingedLongPanel {

    private shopCallback: (() => unknown) | undefined;

    public static TICKET_PER_EMERALDS = 5;

    constructor(scene: Scene, canvas: HTMLCanvasElement, clickSound: BaseSound | undefined, shopCallback: () => unknown, wheelDto:WheelStatusDto) {
        super(scene, canvas, Tr('c.wheel'));

        this.shopCallback = shopCallback;
        let self = this;

        let dec1 = SpriteUtils.addSprite(scene, -80, -175, Keys.IMG_TICKET_BIG, undefined, 0.8);
        let dec2 = SpriteUtils.addSprite(scene, 0, -175, Keys.IMG_TICKET_BIG, undefined, 1.2);
        let dec2b = SpriteUtils.addSprite(scene, 0, -175, Keys.WHEEL_SPLASH, undefined, 1, 0.625);
        let dec3 =  SpriteUtils.addSprite(scene, 80, -175, Keys.IMG_TICKET_BIG, undefined, 0.8);

        let campaignInfo = TextUtils.addTextByFamily(scene, StringUtils.formatString(Tr('tickets.conds'),
                CampaignWheelPanel.TICKET_PER_EMERALDS).toUpperCase(), -58, -70,
            '#ffd465', 17, 'normal', 480-116, Fonts.MYRIADPRO_REGULAR);

        let ticketsInfo = TextUtils.addTextByFamily(scene, Tr('tickets.sources').toUpperCase(), 0, 26,
            '#adffb3', 17, 'normal', 480, Fonts.MYRIADPRO_REGULAR);

        let chancesInfo = new ManualLink(scene, canvas, 0, 83, 'wheelChances', Tr('wheel.det'), '#D0D0D0', true);

        let showGreenMark = wheelDto.freeSpins > 0;
        let freeSpins = wheelDto.freeSpins;

        PlayerStore.fetchWheelCampaignStatus().then((dto: WheelStatusDto) => {
            let rulesText = TextUtils.addTextByFamily(scene, StringUtils.formatString(Tr('camp.wheel.limit'), dto.value, dto.valueMax), 0, 105,
                '#c2c2c2', 11, 'normal', 450, Fonts.MYRIADPRO_REGULAR);
            rulesText.visible = !showGreenMark;

            let dateText = TextUtils.addTextByFamily(scene, Tr('cmp.dates') + dto.dates, 0, 125-(showGreenMark?  20 : 0),
                '#c2c2c2', 11, 'normal', 420, Fonts.MYRIADPRO_REGULAR);

            console.log(dto);

            self.add([dateText, rulesText]);
        });

        this.addCustomButton(0, 207-(showGreenMark?  15 : 0),Tr(showGreenMark? 'to.wheel.free' : 'to.wheel'), Keys.TO_WHEEL_BTN, undefined, Keys.WHEEL_SMALL, () => {
            // PlayerStore.fetchWheelCampaignStatus().then((dto: WheelStatusDto) => {
                let ccp: CampaignWheelPanel2 = new CampaignWheelPanel2(scene, canvas, clickSound, shopCallback, wheelDto);
                PlayerStore.setRemindCampaignRules(false);
                ccp.openAnimated();
                SoundUtils.play(clickSound);
            // });
        });
        let freeTicketsInfo = TextUtils.addTextByFamily(scene, Tr('you.have.free.spins').toUpperCase() + freeSpins, 0, 207+87,
            '#26ca00', Math.ceil(11 * CU.S), 'normal', 480, Fonts.MYRIADPRO_BOLD);

        freeTicketsInfo.visible = showGreenMark;

        SpriteUtils.scale(this.addCustomButton(162, 197-275, Tr('v.magazin').toUpperCase(), Keys.UI_ART_GREEN_BUTTON, undefined, Keys.IMG_TICKET_BIG, this.shopCallback), 0.73 / CU.S, 0.73 / CU.S);

        let greenDot = SpriteUtils.addSprite(scene, 0+55, 207-15 - 60, Keys.IMG_GREEN_DOT, undefined, 1,1);
        greenDot.visible = showGreenMark;

        this.add([dec2b, dec1, dec3, dec2, campaignInfo, ticketsInfo, chancesInfo, greenDot, freeTicketsInfo]);
    }

    protected onClose(): void {

    }

}
